import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import styled from 'styled-components';
import Flex from '../../Flex';
import Error from '../../Error';
import { Base } from '../../Typography';
import { fontSpacingMixin } from '../../mixins/typography';
import { INPUT_FORM_BOTTOM_MARGIN } from '../../Input/constants';
import { getPx } from '../../helpers/common';
import { ExtraSmall as ExtraSmallSpacing } from '../../Typography/constants/extra-small.spacing';
import { styleArrayForBreakpoints } from '../../helpers/media-style';
import { EMPTY_PROPS } from '../../helpers';
var StyledLabel = styled(Base)(_templateObject(), fontSpacingMixin(ExtraSmallSpacing));
var StyledFlex = styled(Flex)(_templateObject2(), function (_ref) {
  var $withBottomMargin = _ref.$withBottomMargin;
  return styleArrayForBreakpoints([$withBottomMargin, INPUT_FORM_BOTTOM_MARGIN], function (_ref2) {
    var $withBottomMargin = _ref2[0],
        $value = _ref2[1];
    return $withBottomMargin ? "margin-bottom: " + getPx($value) + ";" : '';
  });
}, function (_ref3) {
  var $withTopMargin = _ref3.$withTopMargin;
  return styleArrayForBreakpoints([$withTopMargin, INPUT_FORM_BOTTOM_MARGIN], function (_ref4) {
    var $withTopMargin = _ref4[0],
        $value = _ref4[1];
    return $withTopMargin ? "margin-top: " + getPx($value) + ";" : '';
  });
});
var FormItem = /*#__PURE__*/React.forwardRef(function (_ref5, forwardedRef) {
  var _ref5$fullWidth = _ref5.fullWidth,
      fullWidth = _ref5$fullWidth === void 0 ? false : _ref5$fullWidth,
      _ref5$withBottomMargi = _ref5.withBottomMargin,
      withBottomMargin = _ref5$withBottomMargi === void 0 ? false : _ref5$withBottomMargi,
      _ref5$withTopMargin = _ref5.withTopMargin,
      withTopMargin = _ref5$withTopMargin === void 0 ? false : _ref5$withTopMargin,
      _ref5$withNoPaddingFo = _ref5.withNoPaddingForError,
      withNoPaddingForError = _ref5$withNoPaddingFo === void 0 ? false : _ref5$withNoPaddingFo,
      label = _ref5.label,
      error = _ref5.error,
      _ref5$errorProps = _ref5.errorProps,
      errorProps = _ref5$errorProps === void 0 ? EMPTY_PROPS : _ref5$errorProps,
      _ref5$labelProps = _ref5.labelProps,
      labelProps = _ref5$labelProps === void 0 ? EMPTY_PROPS : _ref5$labelProps,
      _ref5$showError = _ref5.showError,
      showError = _ref5$showError === void 0 ? true : _ref5$showError,
      _ref5$absoluteError = _ref5.absoluteError,
      absoluteError = _ref5$absoluteError === void 0 ? false : _ref5$absoluteError,
      _ref5$visibleError = _ref5.visibleError,
      visibleError = _ref5$visibleError === void 0 ? true : _ref5$visibleError,
      children = _ref5.children,
      id = _ref5.id,
      name = _ref5.name,
      props = _objectWithoutPropertiesLoose(_ref5, ["fullWidth", "withBottomMargin", "withTopMargin", "withNoPaddingForError", "label", "error", "errorProps", "labelProps", "showError", "absoluteError", "visibleError", "children", "id", "name"]);

  var displayedErrorProps = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, id ? {
      'data-error-id': id
    } : {}), name ? {
      'data-error-name': name
    } : {}), errorProps);
  }, [id, name, errorProps]);
  return /*#__PURE__*/React.createElement(StyledFlex, _extends({
    ref: forwardedRef,
    direction: "ttb",
    fullWidth: fullWidth,
    $withBottomMargin: withBottomMargin,
    $withTopMargin: withTopMargin
  }, props), label && /*#__PURE__*/React.createElement(StyledLabel, _extends({
    as: "label",
    strong: true,
    withBottomMargin: true,
    htmlFor: id
  }, labelProps), label), children, /*#__PURE__*/React.createElement(Error, _extends({
    error: error,
    show: showError,
    visible: visibleError,
    absolute: absoluteError,
    noPadding: withNoPaddingForError
  }, displayedErrorProps)));
});
export default FormItem;